import axios from "../axios";

const getStatistic = async function (accessToken, params) {
    try {
        const response = await axios.post('dashboard/getStatistic', params, {
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default getStatistic;
